<template>
  <v-container fluid>
    <h2 class="mt-5 mb-6">{{$t('master_data')}}</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
        <v-tab v-if="!gcLeaveBalanceEnabled">{{$t('leave_category')}}</v-tab>
        <v-tab>{{$t('overtime_category')}}</v-tab>
        <v-tab v-if="gcClaimEnabled">{{$t('claim_category')}}</v-tab>
        <v-tab>{{$t('position')}}</v-tab>
        <v-tab>{{$t('grade')}}</v-tab>
        <v-tab>{{$t('employee_status')}}</v-tab>

        <v-tab-item v-if="!gcLeaveBalanceEnabled">
          <v-container fluid >
            <Leave v-if="tabActive == 0"></Leave>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Overtime v-if="tabActive == (gcLeaveBalanceEnabled ? 0 : 1)"></Overtime>
          </v-container>
        </v-tab-item>
        <v-tab-item v-if="gcClaimEnabled">
          <v-container fluid>
            <Reimbursement v-if="tabActive == (gcLeaveBalanceEnabled ? 1 : 2)"></Reimbursement>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <job-position></job-position>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Grade/>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <MasterEmployeeStatus/>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
// import axios from "axios";
import Leave from "./components/Leave";
import Reimbursement from "./components/ReimbursementCategory";
import Overtime from "./components/Overtime";
import JobPosition from './components/JobPosition.vue'
import MasterEmployeeStatus from './components/MasterEmployeeStatus.vue'
import Grade from './components/Grade.vue'

export default {
  name: "MasterData",
  data() {
    return {
      tabActive: 0,
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e;
    },
  },
  computed: {
    gcClaimEnabled() {
      return this.$store.getters.gcGetData('feature_claim', 'is_enabled')
    },
    gcLeaveBalanceEnabled() {
        return this.$store.getters.gcGetData('feature_leave', 'balance_is_enabled')
      },
  },
  created() {
    if(this.gcLeaveBalanceEnabled){
        this.tabActive = 1
    }
  },
  components: {
    Leave,
    Reimbursement,
    Overtime,
    JobPosition,
    MasterEmployeeStatus,
    Grade,
  },
};
</script>
